import { Link } from "react-router-dom";
import { MapPin, Navigation } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, ADDRESS, DIRECTIONS_URL } from "@/lib/content";

export const Footer = () => (
  <footer className="relative bg-navy text-ivory grain" data-testid="site-footer">
    <div className="container-x grid gap-14 py-20 md:grid-cols-12">
      <div className="md:col-span-5">
        <Logo tagline className="h-16" />
        <p className="mt-8 max-w-sm text-sm leading-relaxed text-ivory/65">
          An owner-operated hotel management company in the Kansas City metro. Local owners, brand standards and a team on property every day.
        </p>
      </div>
      <div className="md:col-span-3">
        <p className="eyebrow text-gold">Explore</p>
        <ul className="mt-6 grid grid-cols-2 gap-x-6 gap-y-3 md:grid-cols-1">
          {[{ to: "/", label: "Home" }, ...NAV, { to: "/contact", label: "Contact" }].map((n) => (
            <li key={n.to}>
              <Link to={n.to} className="text-sm text-ivory/75 transition-colors hover:text-gold" data-testid={`footer-link-${n.to === "/" ? "home" : n.to.slice(1)}`}>
                {n.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="md:col-span-4">
        <p className="eyebrow text-gold">Visit</p>
        <address className="mt-6 flex items-start gap-3 text-sm not-italic leading-relaxed text-ivory/80" data-testid="footer-address">
          <MapPin className="mt-0.5 h-4 w-4 flex-none text-gold" />
          <span>
            {ADDRESS.name}
            <br />
            {ADDRESS.street}
            <br />
            {ADDRESS.city}
          </span>
        </address>
        <a href={DIRECTIONS_URL} target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center gap-2 text-sm text-gold hover:text-gold-light" data-testid="footer-directions-link">
          <Navigation className="h-4 w-4" /> Get directions
        </a>
        <div>
          <Link to="/contact" className="btn-outline-light mt-8" data-testid="footer-contact-button">
            Start a conversation
          </Link>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="container-x flex flex-col gap-3 py-6 text-xs text-ivory/50 md:flex-row md:items-center md:justify-between">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} MSK Hotels. All rights reserved.</p>
        <p className="md:text-center" data-testid="footer-credit">Website design by Hopbots</p>
        <p className="max-w-md md:text-right">Brand names and logos are trademarks of their respective owners.</p>
      </div>
    </div>
  </footer>
);
